<ng-container>
  <div class="modal-body text-center">
    <object type="application/pdf" data="assets/doc/Terminos_y_condiciones.pdf" width="100%" height="500" style="height: 85vh;" *ngIf="tipo === 'pdf'">No Support</object>

    <object type="application/pdf" data="assets/doc/Declaracion_medico_tratante.pdf" width="100%" height="500" style="height: 85vh;" *ngIf="tipo === 'medicotratantepdf'">No Support</object>
    <img src="assets/img/!.png" *ngIf="tipo === ''">
    <div *ngIf="imagen !== ''">
      <img [src]="imagen">
    </div>

    <h2 class="text-grey bold">
      {{ mensaje }}
    </h2>
  </div>
  <div class="row mb-4 text-center" *ngIf="boton === true" >
    <div class="col-12">
      <button class="btn-gral next  animated bounceIn slow" (click)="closeModal()">
        <i class="fas fa-chevron-left mr-4" *ngIf="modulo !== 'bono-ges'"></i>
        {{ botonText }}
        <i class="fas fa-chevron-right ml-4" *ngIf="modulo === 'bono-ges'"></i>
      </button>
    </div>
  </div>
</ng-container>
